import React, { useLayoutEffect, useRef } from 'react';
import * as StatsActions from '../../actions/StatsActions'

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_dark from "@amcharts/amcharts4/themes/dark";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { StringHelper } from '../../helpers/StringHelper';

am4core.useTheme(am4themes_dark);
am4core.useTheme(am4themes_animated);

export interface IStepLineChartSeriesProps {
    name: string;
    data: Array<StatsActions.IMaxDifficultyPassStatisticsType>;
  }

export interface IStepLineChartProps {
    id: string;
    xAxisTitle: string;
    yAxisTitle: string;
    data: Array<IStepLineChartSeriesProps>
  }

const StepLineChart: React.FC<IStepLineChartProps> = (props: IStepLineChartProps) => {
    const chart = useRef();

    useLayoutEffect(() => {
        let c = am4core.create(`${props.id}`, am4charts.XYChart);

        chart.current = c as any;
    
        // Create chart
        c.paddingRight = 20;

        let dateAxis = c.xAxes.push(new am4charts.DateAxis());
        dateAxis.renderer.minGridDistance = 50;
        dateAxis.title.text = props.xAxisTitle;
        dateAxis.baseInterval = {timeUnit:"day", count:1};

        let valueAxis: any = c.yAxes.push(new am4charts.ValueAxis());
        valueAxis.tooltip.disabled = true;
        valueAxis.title.text = props.yAxisTitle;

        c.cursor = new am4charts.XYCursor();
        c.cursor.xAxis = dateAxis;
        c.cursor.fullWidthLineX = true;
        c.cursor.lineX.strokeWidth = 0;
        c.cursor.lineX.fill = c.colors.getIndex(2);
        c.cursor.lineX.fillOpacity = 0.1;

        c.scrollbarX = new am4core.Scrollbar();

        c.legend = new am4charts.Legend();
        c.legend.position = "top";

        for (var i = 0; i < props.data.length; i++) {
            let seriesProps = props.data[i];
            let seriesData = [];
            for (var j = 0; j < seriesProps.data.length; j++) {
                let entry = seriesProps.data[j];
                let localDate = new Date(entry.date);
                seriesData.push({
                    date: localDate,
                    value: entry.value,
                    notechartName: StringHelper.escapeAmchartsString(entry.notechartName),
                    songName: StringHelper.escapeAmchartsString(entry.songName),
                });
            }

            let series = c.series.push(new am4charts.StepLineSeries());
            series.name = seriesProps.name;
            series.dataFields.dateX = "date";
            series.dataFields.valueY = "value";
            series.tooltipText = "Difficulty: {valueY.value}\nSong: {songName}\nNotechart: {notechartName}";
            series.strokeWidth = 3;
            series.data = seriesData;
        }

        //c.data = data;
    
        return () => {
            c.dispose();
        };
      }, [props]);
    
    return (
        <div className="StepLineChart" id={props.id} style={{ width: "100%", height: "500px" }}></div>
    );
  }
  
  export default StepLineChart;